
import * as React from 'react';
import { Loading } from '../../uiComponents/Loading';
import { LinkPrimaryButton } from '../../uiComponents/input/Buttons';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { KonkurrenceTable } from './KonkurrenceTable';
import { MenuItemDto, TextFormGroup } from '../../uiComponents/input/FormGroups';
import { Row, Col, Grid } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { KonkurrencestatusEnum } from '../../models/enums/KonkurrencestatusEnum';
import { SkoleaarDropdown } from '../../uiComponents/input/SkoleaarDropDown';
import { KonkurrenceFilter } from '../../models/KonkurrenceFilter';
import { Konkurrence } from '../../models/Konkurrence';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import TableFormatters from '../../uiComponents/table/TableFormatters';
import { getSkoleaarFromDate } from '../../models/SkoleAar';
import Autocomplete from '../../uiComponents/input/Autocomplete';
import { getBackendBaseUrl } from '../../infrastructure/BackendUrlResolver';
import { getLoggedInBruger } from '../../infrastructure/Security';

export interface KonkurrenceListAdminProps {
}

interface KonkurrenceListAdminState {
    konkurrencer?: Konkurrence[];
    konkurrenceFilter: KonkurrenceFilter;
}

class KonkurrenceListAdmin extends React.Component<KonkurrenceListAdminProps, KonkurrenceListAdminState> {
    constructor(props: KonkurrenceListAdminProps) {
        super(props);

        this.state = { konkurrencer: undefined, konkurrenceFilter: new KonkurrenceFilter() };
        this.onFilterChanged = this.onFilterChanged.bind(this);
    }

    componentDidMount() {
        var self = this;
        var result = createApiCaller().getKonkurrencer();
        result.then(function (json: any) {
            self.setState({ konkurrencer: json });
        });
    }

    applyFilter(filter: KonkurrenceFilter, konkurrencer?: Konkurrence[]): Konkurrence[] {
        if (konkurrencer === undefined) {
            return [];
        }

        let konkurrencerFiltered = konkurrencer.filter(k => {
            return filter.statusList.indexOf(k.status) > -1;
        });

        const searchTerm = filter.search === undefined ? '' : filter.search.toLowerCase();
        konkurrencerFiltered = konkurrencerFiltered.filter(k =>
            k.titel.toLowerCase().indexOf(searchTerm) > -1 ||
            k.afviklingssted.toLowerCase().indexOf(searchTerm) > -1 ||
            k.maxAntalHold.toString().indexOf(searchTerm) > -1
        );

        konkurrencerFiltered = konkurrencerFiltered.filter(k => {
            const y: number = getSkoleaarFromDate(k.startdato);
            return Number(y) === Number(filter.skoleaar);
        });

        return konkurrencerFiltered;
    }

    onFilterChanged(name: string, value: any) {
        const filter = this.state.konkurrenceFilter;
        filter[name] = value;

        this.setState({ konkurrenceFilter: filter });
    }

    render() {
        const konkurrencer = this.applyFilter(this.state.konkurrenceFilter, this.state.konkurrencer);
        const excelExportUrl = `${getBackendBaseUrl()}/api/konkurrence/ExportKonkurrenceOverblik/${getLoggedInBruger().id}`;
        const exportTilmeldingerUrl = `${getBackendBaseUrl()}/api/tilmelding/ExportTilmeldingOverblik?skoleAar=${this.state.konkurrenceFilter.skoleaar}`;

        let buttons = (
            <div className='multiple-buttons'>
                <a href={exportTilmeldingerUrl} className='btn btn-secondary'>Eksporter tilmeldinger</a>
                <a href={excelExportUrl} className='btn btn-secondary'>Eksporter liste</a>
                <LinkPrimaryButton url={'/konkurrence/ny'} text={'Ny konkurrence'} />
            </div>
        );

        let statusList: MenuItemDto[] = [];
        statusList.push(new MenuItemDto(KonkurrencestatusEnum.Offentlig, 'Offentlig'));
        statusList.push(new MenuItemDto(KonkurrencestatusEnum.IkkePubliceret, 'Ikke publiceret'));
        statusList.push(new MenuItemDto(KonkurrencestatusEnum.Afviklet, 'Afviklet'));
        statusList.push(new MenuItemDto(KonkurrencestatusEnum.Slettet, 'Slettet'));

        var selectedStatus = this.state.konkurrenceFilter.statusList.map((k: KonkurrencestatusEnum) => {
            return new MenuItemDto(k, TableFormatters.getStatusText(k));
        });

        return (
            <PageWrapper>
                <PageTitle title='Konkurrencer' />
                <div id='controls-wrapper'>
                    <Grid>
                        <Row>
                            <Col md={3}>
                                <SkoleaarDropdown
                                    onChange={this.onFilterChanged}
                                    selectedValue={this.state.konkurrenceFilter.skoleaar}
                                />
                            </Col>
                            <Col md={5}>
                                <Autocomplete
                                    errorMessages={[]}
                                    label='Status'
                                    name='statusList'
                                    selected={selectedStatus}
                                    onChange={this.onFilterChanged}
                                    data={statusList}
                                />
                            </Col>
                            <Col md={4}>
                                <TextFormGroup
                                    errorMessages={[]}
                                    label='Søg efter konkurrence'
                                    name='search'
                                    value={this.state.konkurrenceFilter.search}
                                    onChange={this.onFilterChanged}
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
                <ContentWrapper>
                    <Loading isLoading={this.state.konkurrencer === undefined}>
                        <SectionGroup header={konkurrencer.length + ' konkurrencer'} buttons={buttons}>
                            <Section fullWidth={true}>
                                <KonkurrenceTable konkurrencer={konkurrencer} pagination={true} />
                            </Section>
                        </SectionGroup>
                    </Loading>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default KonkurrenceListAdmin;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceListAdmin.tsx